import React, { useState } from 'react';
import InvestIcon from '../../../../assets/invest-icon.svg';
import InvestDarkIcon from '../../../../assets/invest-dark-icon.svg';
import InvestErrorIcon from '../../../../assets/invest-red-icon.svg';
import CheckedIcon from '../../../../assets/checked-icon.svg';
import PlusGreenIcon from '../../../../assets/plus-bold-icon.svg';
import WarningIcon from '../../../../assets/warning-error-icon.svg';
import { Tooltip } from '@chakra-ui/react';

const InvestmentButton = ({ article, setModal }) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const handleTooltipClick = () => {
    setIsTooltipOpen(!isTooltipOpen);
  };

  const handleMouseEnter = () => {
    setIsTooltipOpen(true);
  };

  const handleMouseLeave = () => {
    setIsTooltipOpen(false);
  };

  const hasInvested = !!article?.investmentData?.pointInvested;
  const isFollowing = article?.creator?.isFollowing;
  const investorCount = article?.investmentData?.totalInvestors || 0;

  const isWarningState = hasInvested && !isFollowing;

  const getButtonStyles = () => {
    if (hasInvested) {
      return isFollowing ? 'border-[#87C98A] bg-growth-green-200' : 'border-[#FFBCBC] bg-[#FFF1F1]';
    }
    return 'border-[#C8E6C9] bg-06-seasalt-white';
  };

  const getIcon = () => {
    if (hasInvested) {
      return isFollowing ? InvestDarkIcon : InvestErrorIcon;
    }
    return InvestIcon;
  };

  const getTextColor = () => {
    return hasInvested
      ? isFollowing
        ? 'text-growth-green-900'
        : 'text-error-red'
      : 'text-growth-green-900';
  };

  const getStatusIcon = () => {
    if (!hasInvested) {
      return <img src={PlusGreenIcon} alt="" className="w-4 h-4 md:w-5 md:h-5" />;
    }

    return isFollowing ? (
      <img src={CheckedIcon} alt="" className="w-4 h-4 md:w-5 md:h-5" />
    ) : (
      <img src={WarningIcon} alt="" className="w-4 h-4 md:w-5 md:h-5" />
    );
  };

  const ButtonComponent = () => (
    <div
      className={`flex gap-1 items-center py-1 px-2 border ${getButtonStyles()} rounded-[80px] w-fit cursor-pointer hover:opacity-80`}
      onClick={() => {
        handleClick();
        handleTooltipClick();
        if (hasInvested && !isFollowing) return;
        setModal('invest-article');
      }}
      onMouseEnter={() => handleMouseEnter()}
      onMouseLeave={() => handleMouseLeave()}
    >
      <img src={getIcon()} alt="Investment icon" className="w-4 h-4 md:w-6 md:h-6" />
      <p className={`${getTextColor()} text-xs md:text-sm font-[800]`}>
        {investorCount > 0
          ? `${investorCount} ${investorCount === 1 ? 'Investor' : 'Investors'}`
          : 'Invest'}
      </p>
      {getStatusIcon()}
    </div>
  );

  const handleClick = () => {
    if (article?.creator?.isFollowing) {
      setModal('invest-article');
    }
  };

  return isWarningState ? (
    <Tooltip
      rounded="0.75rem"
      label={'Your investment is frozen since you unfollowed the writer. Re-follow to restore it.'}
      placement={'top'}
      zIndex={0}
      maxW={'300px'}
      bg="#E6E7EB"
      p={4}
      fontSize={'xs'}
      color={'#204A22'}
      isOpen={isTooltipOpen}
    >
      <span>
        <ButtonComponent />
      </span>
    </Tooltip>
  ) : (
    <ButtonComponent />
  );
};

export default InvestmentButton;
